import React from "react";
import { Alert as AlertMui } from "@material-ui/lab";

export const Alert = ({ children, severity }) => {
    return <AlertMui severity={severity}>{ children }</AlertMui>
}
